import Icon from '@material-ui/core/Icon';
import React, { memo, useCallback, useEffect } from 'react';

import useScrollBlock from './hook';
import styles from './styles';

interface IProps {
  open: boolean;
  onClose: () => void;
  title: string | JSX.Element;
  children: React.ReactNode;
}

const QuickView = memo(({ open, onClose, title, children }: IProps) => {
  const classes = styles();
  const [blockScroll, allowScroll] = useScrollBlock();

  const handleClose = useCallback(() => {
    onClose();
  }, [onClose]);

  useEffect(() => {
    if (open) {
      return blockScroll();
    }

    allowScroll();

    return () => allowScroll();
  }, [open, blockScroll, allowScroll]);

  return (
    <>
      {open && <div className={classes.overlay} onClick={() => handleClose()} />}

      <div className={`${classes.quickview} ${open ? '--active' : ''}`}>
        {open && (
          <>
            <div className='header'>
              <div className='title'>{title}</div>

              <div className='close' onClick={() => handleClose()}>
                <Icon>close</Icon>
              </div>
            </div>

            <div className='body'>
              <div className='content'>{children}</div>
            </div>
          </>
        )}
      </div>
    </>
  );
});

export default QuickView;
